import script from "./DurataTable1.vue?vue&type=script&setup=true&lang=js"
export * from "./DurataTable1.vue?vue&type=script&setup=true&lang=js"

import "./DurataTable1.vue?vue&type=style&index=0&id=eaccc9c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eaccc9c0"]])

export default __exports__